module.exports = __webpack_public_path__ + "img/alerts-1-mobile.6519c046.gif";